'use strict';
document.addEventListener('DOMContentLoaded', () => {
const $=(s,r)=>(r||document).querySelector(s);
const $$=(s,r)=>Array.from((r||document).querySelectorAll(s));
const reduceMotion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* ---------- generic tabs (Buy vs Rent panel) ---------- */
  document.addEventListener('click', e => {
    const tab = e.target.closest('[role="tab"]');
    if (!tab || !tab.closest('.choice-tabs')) return;
    const tabs = $$('[role="tab"]', tab.closest('.choice-tabs'));
    tabs.forEach(t => {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      const pane = document.getElementById(t.getAttribute('aria-controls'));
      if (pane) pane.hidden = !selected;
    });
  });
  document.addEventListener('keydown', e => {
    const tab = e.target.closest('[role="tab"]');
    if (!tab || !tab.closest('.choice-tabs')) return;
    const tabs = $$('[role="tab"]', tab.closest('.choice-tabs'));
    let next = null;
    if (e.key === 'ArrowRight') next = tabs[(tabs.indexOf(tab) + 1) % tabs.length];
    if (e.key === 'ArrowLeft') next = tabs[(tabs.indexOf(tab) - 1 + tabs.length) % tabs.length];
    if (e.key === 'Home') next = tabs[0];
    if (e.key === 'End') next = tabs[tabs.length - 1];
    if (next) { e.preventDefault(); next.click(); next.focus(); }
  });

  /* ---------- FAQ accordion slide animation ---------- */
  document.addEventListener('click', e => {
    const summary = e.target.closest('.faq-list summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || details.dataset.animating) return;
    e.preventDefault();
    if (reduceMotion()) { details.open = !details.open; return; }
    details.dataset.animating = '1';
    details.style.overflow = 'hidden';
    const start = details.offsetHeight;
    const cleanup = anim => {
      details.style.overflow = '';
      delete details.dataset.animating;
      anim.onfinish = anim.oncancel = null;
    };
    if (details.open) {
      const anim = details.animate(
        { height: [`${start}px`, `${summary.offsetHeight}px`] },
        { duration: 280, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
      anim.onfinish = () => { details.open = false; cleanup(anim); };
      anim.oncancel = () => cleanup(anim);
    } else {
      details.open = true;
      const anim = details.animate(
        { height: [`${start}px`, `${details.offsetHeight}px`] },
        { duration: 280, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
      anim.onfinish = () => cleanup(anim);
      anim.oncancel = () => cleanup(anim);
    }
  });

    const rail = $('#campaign-rail');
    if (rail) {
      const cards = $$('.campaign-product', rail);
      const viewport = rail.parentElement;
      const carousel = viewport.parentElement;
      const controls = $('#campaign-controls');
      const previous = $('.campaign-slider-previous', carousel);
      const next = $('.campaign-slider-next', carousel);
      const dots = $('.campaign-slider-dots', controls);
      const counter = $('.campaign-slide-counter', controls);
      const status = $('#campaign-slide-status');
      const slack = 8;
      let index = 0;
      let positions = [0];
      let dotButtons = [];
      if (cards.length && previous && next) {
      const measure = () => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        const maxScroll = Math.max(0, rail.scrollWidth - viewport.clientWidth);
        const snaps = [0];
        if (maxScroll >= slack && step > 0) {
          for (let offset = step; offset < maxScroll - 1 && snaps.length < cards.length; offset += step) snaps.push(offset);
          if (Math.abs(snaps[snaps.length - 1] - maxScroll) > 1) snaps.push(maxScroll);
        }
        return { step, maxScroll, snaps };
      };
      const showProducts = requested => {
        const { step, maxScroll, snaps } = measure();
        positions = snaps;
        index = Math.max(0, Math.min(requested, positions.length - 1));
        const position = positions[index];
        if (dotButtons.length !== positions.length) {
          dots.innerHTML = positions.map((_, i) => `<button class="campaign-slider-dot" type="button" aria-label="Show product slide ${i + 1} of ${positions.length}"></button>`).join('');
          dotButtons = $$('.campaign-slider-dot', dots);
          dotButtons.forEach((dot, i) => dot.addEventListener('click', () => showProducts(i)));
        }
        rail.style.transform = `translate3d(${-position}px, 0, 0)`;
        const viewRight = position + viewport.clientWidth;
        let firstVisible = -1;
        let lastVisible = -1;
        cards.forEach((card, i) => {
          const left = card.offsetLeft;
          const right = left + card.offsetWidth;
          const shown = right > position + 1 && left < viewRight - 1;
          card.inert = !shown;
          card.setAttribute('aria-hidden', String(!shown));
          if (shown) {
            if (firstVisible < 0) firstVisible = i;
            lastVisible = i;
          }
        });
        const peeking = maxScroll - position > slack;
        const receding = position > slack && step > 0 && Math.abs(position % step) > 1;
        carousel.classList.toggle('is-peeking', peeking);
        carousel.classList.toggle('is-receding', receding);
        previous.hidden = previous.disabled = index === 0;
        next.hidden = next.disabled = !peeking;
        dotButtons.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const from = firstVisible < 0 ? 1 : firstVisible + 1;
        const to = lastVisible < 0 ? from : lastVisible + 1;
        status.textContent = `Showing products ${from} to ${to} of ${cards.length}`;
        counter.textContent = `${index + 1} / ${positions.length}`;
        controls.hidden = positions.length < 2;
      };
      previous.addEventListener('click', () => showProducts(index - 1));
      next.addEventListener('click', () => showProducts(index + 1));
      let touchStart = null;
      viewport.addEventListener('touchstart', event => {
        const touch = event.changedTouches[0];
        touchStart = { x: touch.clientX, y: touch.clientY };
      }, { passive: true });
      viewport.addEventListener('touchend', event => {
        if (!touchStart) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) showProducts(index + (dx < 0 ? 1 : -1));
        touchStart = null;
      }, { passive: true });
      rail.addEventListener('focusin', event => {
        const card = event.target.closest('.campaign-product');
        if (!card || !rail.contains(card)) return;
        const { snaps } = measure();
        const position = positions[index] || 0;
        const left = card.offsetLeft;
        const right = left + card.offsetWidth;
        const clipped = left < position - 1 || right > position + viewport.clientWidth + 1;
        if (!clipped) return;
        let target = snaps.length - 1;
        for (let i = 0; i < snaps.length; i++) {
          const pos = snaps[i];
          if (left >= pos - 1 && right <= pos + viewport.clientWidth + 1) {
            target = i;
            break;
          }
        }
        if (target !== index) showProducts(target);
      });
      if (typeof ResizeObserver === 'function') new ResizeObserver(() => showProducts(index)).observe(viewport);
      window.addEventListener('resize', () => showProducts(index));
      showProducts(0);
      }
    }
    const reviews = $('#review-cards');
    if (reviews) {
      const controls = $('#review-controls');
      if (controls && reviews.children.length > 1) {
        const slides = $$('.testimonial-card', reviews);
        const dots = $('.review-dots', controls);
        const status = $('#review-slide-status');
        let current = 0;
        let ghost = null;
        dots.innerHTML = slides.map((_, i) => `<button class="review-dot" type="button" aria-label="Show review ${i + 1} of ${slides.length}"${i === 0 ? ' aria-current="true"' : ''}></button>`).join('');
        const dotButtons = $$('.review-dot', dots);
        const showReview = (next, announce = true) => {
          const target = (next + slides.length) % slides.length;
          if (announce && target === current) return;
          reviews.getAnimations().forEach(animation => animation.cancel());
          if (ghost) {
            ghost.remove();
            ghost = null;
          }
          const animate = announce && !reduceMotion() && typeof reviews.animate === 'function';
          const forward = (target - current + slides.length) % slides.length <= slides.length / 2;
          if (animate) {
            ghost = reviews.cloneNode(true);
            ghost.removeAttribute('id');
            ghost.classList.add('testimonial-ghost');
            ghost.setAttribute('aria-hidden', 'true');
            ghost.inert = true;
            reviews.parentElement.append(ghost);
          }
          current = target;
          const previous = (current - 1 + slides.length) % slides.length;
          const following = (current + 1) % slides.length;
          slides.forEach((slide, i) => {
            const position = i === current ? 'current' : slides.length > 2 && i === previous ? 'previous' : slides.length > 2 && i === following ? 'next' : '';
            slide.hidden = !position;
            if (position) slide.dataset.position = position;
            else delete slide.dataset.position;
            slide.inert = i !== current;
            if (i === current) slide.removeAttribute('aria-hidden');
            else slide.setAttribute('aria-hidden', 'true');
          });
          dotButtons.forEach((dot, i) => {
            if (i === current) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (announce) status.textContent = `Review ${current + 1} of ${slides.length}`;
          if (ghost) {
            const offset = forward ? '28%' : '-28%';
            const exit = forward ? '-28%' : '28%';
            const timing = { duration: 380, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' };
            reviews.animate([
              { transform: `translate3d(${offset}, 0, 0)`, opacity: 0.35 },
              { transform: 'translate3d(0, 0, 0)', opacity: 1 }
            ], timing);
            const outgoing = ghost;
            outgoing.animate([
              { transform: 'translate3d(0, 0, 0)', opacity: 1 },
              { transform: `translate3d(${exit}, 0, 0)`, opacity: 0 }
            ], timing).finished.then(() => {
              outgoing.remove();
              if (ghost === outgoing) ghost = null;
            }).catch(() => {});
          }
        };
        $('.review-previous', controls).addEventListener('click', () => showReview(current - 1));
        $('.review-next', controls).addEventListener('click', () => showReview(current + 1));
        dotButtons.forEach((dot, i) => dot.addEventListener('click', () => showReview(i)));
        showReview(0, false);
        controls.hidden = false;
      }
    }

});
